import { z } from "zod";

export const emailExistsSchema = z.object({
  exists: z.boolean(),
  use_magic_link_flow: z.boolean(),
});

export type EmailExists = z.infer<typeof emailExistsSchema>;
